import React, { useEffect, useRef, useState} from 'react'
import styles from './EmergencyPage.module.css'
import {
    Button, Dialog, DialogActions, DialogContent, DialogContentText,
} from '@material-ui/core'

import axios from "axios";
import LoadingBackdrop from "../../../components/common/LoadingBackdrop";
import Snackbar from "@mui/material/Snackbar";
import {Alert, Container, FormControl, Grid} from "@mui/material";
import Box from "@mui/material/Box";
import TextField from "@mui/material/TextField";
import AutocompleteSelect from "../../../components/common/inputs/AutoCompleteSelectInput";
import HookForm from "../../../components/common/HookForm";
import {useForm} from "react-hook-form";

interface FormData {
    customernumber: string
    customerdivisionid: number
    customerworkcode: string
    customerrelease: string
}
const EmergencyPage = (params) => {
    const [snackbarOpen, setSnackbarOpen] = React.useState({ open: false, message: '' })
    const [dialogMsg, setDialogMsg] = React.useState( '');
    const [loadingBackdrop, setLoadingBackdrop] = React.useState(false)
    const [customerNumber, setCustomerNumber] = useState("");
    const [customerRelease, setCustomerRelease] = useState("");
    const [customerWorkCode, setCustomerWorkCode] = useState("");
    const [customerDivisionOptions, setCustomerDivisionOptions] = React.useState([]);
    const [errors, setErrors] = useState({
        customernumber: '',
    });

    const formMethods = useForm<FormData>()
    const { setValue} = formMethods

    useEffect(() => {
        params.setTitle('Emergency')

        axios.get('/fieldsystememergencydropdowns', {}).then((response) => {
            const parsedData = JSON.parse(response.data.jsonString)
            console.log(parsedData)

            setValue('customerdivisionid', Number(parsedData?.selectedustomerdivisionid));
            setCustomerDivisionOptions(parsedData?.customerdivisionlist?.filter(item => item.customerdivisionactive)?.map(custDivision => {
                return { label: custDivision.customerdivisioncode, value: custDivision.customerdivisionid, key: custDivision.customerdivisionid }
            }))
        })
    }, [])

    const onSubmit = async (formdata: FormData) => {
        debugger
        if (validate()) {
            setLoadingBackdrop(true)
            const body = {
                customernumber: customerNumber,
            }

            if (customerRelease) {
                body['customerrelease'] = customerRelease
            }

            if (customerWorkCode) {
                body['customerworkcode'] = customerWorkCode
            }

            if (formdata.customerdivisionid > 0) {
                body['customerdivisionid'] = formdata.customerdivisionid
            }

            axios.post(`fieldsystememergency`, body).then((response) => {
                const parsedResponse = JSON.parse(response?.data.jsonString)
                setLoadingBackdrop(false)
                setDialogMsg('Created Work Order - ' + parsedResponse.woid)
            })
        }
    }

    const validate = () => {
        let isValid = true;
        let newErrors = {
            customernumber: "",
        }

        if (!customerNumber) {
            newErrors.customernumber = "Please a customer number.";
            isValid = false;
        }

        setErrors(newErrors)
        return isValid
    }


    const handleSnackbarClose = (event: React.SyntheticEvent | Event, reason?: string) => {
        if (reason === 'clickaway') {
            return;
        }

        setSnackbarOpen({ open: false, message: ""  });
    }

    const closeDialog = () => {
        setDialogMsg("")
        params.handleBackArrow('main')
    }

    return (
        <div className={styles.root}>
            <LoadingBackdrop open={loadingBackdrop} />
            <>
                <Dialog
                    open={dialogMsg.length > 0}
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description"
                >
                    <DialogContent>
                        <DialogContentText id="alert-dialog-description">
                            {dialogMsg}
                        </DialogContentText>
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={closeDialog}>Ok</Button>
                    </DialogActions>
                </Dialog>
            </>
            <>
                <Snackbar
                    open={snackbarOpen.open}
                    autoHideDuration={4000}
                    onClose={handleSnackbarClose}
                    anchorOrigin={{vertical: 'bottom', horizontal: 'center'}}
                >
                    <Alert severity="success">
                        {snackbarOpen.message}
                    </Alert>
                </Snackbar>
            </>
            <>
                <div style={{display: loadingBackdrop ? 'none' : 'inline-flex'}}>
                    <Container>
                        <Box>
                            <Grid
                                container
                                border={0}
                                direction="row"
                                alignItems="center"
                                justifyContent="center"
                                height={'100%'}
                                width={'100%'}
                            >
                                <>
                                    <Grid item border={0} marginRight={1} md={8} xs={8}>
                                        <HookForm
                                            methods={formMethods}
                                            onSubmit={onSubmit}
                                            className={styles.form}
                                            formProps={{ id: 'items-form' }}
                                        >
                                        {/*<div style={{marginBottom: '50', justifyContent: 'center', alignItems: 'center', alignContent:'center'}} >Add vacation days.</div>*/}
                                            <TextField
                                                // margin="dense"
                                                id="customernumber"
                                                name="customernumber"
                                                label="Customer Number"
                                                type="number"
                                                fullWidth
                                                required
                                                size={'small'}
                                                error={!!errors.customernumber}
                                                helperText={errors.customernumber}
                                                defaultValue={customerNumber}
                                                value={customerNumber}
                                                onChange={(e) => setCustomerNumber(e.target.value)}
                                            />
                                            <TextField
                                                // margin="dense"
                                                id="customerrelease"
                                                name="customerrelease"
                                                label="Customer Release"
                                                fullWidth
                                                size={'small'}
                                                value={customerRelease}
                                                onChange={(e) => {
                                                    const digitsOnly = e.target.value.replace(/\D/g, '').slice(0, 9)
                                                    setCustomerRelease(digitsOnly)
                                                }}
                                                inputProps={{
                                                    inputMode: 'numeric',
                                                    maxLength: 9
                                                }}
                                            />
                                            <TextField
                                                // margin="dense"
                                                id="customerworkcode"
                                                name="customerworkcode"
                                                label="Customer Work Code"
                                                fullWidth
                                                size={'small'}
                                                value={customerWorkCode}
                                                onChange={(e) => setCustomerWorkCode(e.target.value)}
                                            />
                                            <FormControl fullWidth>
                                                <AutocompleteSelect
                                                    name="customerdivisionid"
                                                    label="Customer Division"
                                                    disabled={false}
                                                    options={customerDivisionOptions}
                                                />
                                            </FormControl>
                                            <Button
                                                style={{marginTop: '20px', alignItems: 'center', width: '100%'}}
                                                variant="contained"
                                                className={styles.submitButton}
                                                type="submit"
                                                // onClick={() => {onSubmit()}}
                                                form="items-form">
                                                Submit
                                            </Button>
                                        </HookForm>
                                    </Grid>
                                </>
                            </Grid>
                        </Box>
                    </Container>
                </div>

            </>
        </div>
    )
}

export default EmergencyPage